export interface ModelType {
  name: string
  taskInfoExpanded: {
    key: string
    value:
      | string
      | {
          id: string
          name: string
        }
      | {
          device_ip: string
          device_brand: string
        }
      | { [key: string]: string | number }
      | string[]
      | { value: string | number; type: string; default?: string }[]
    type: string
    deepType?:
      | {
          id: string
          name: string
        }
      | { device_ip: string; device_brand: string }
  }[]
  taskInfo: {
    key: string
    value:
      | string
      | {
          id: string
          name: string
        }[]
      | { [key: string]: string | number }
      | string[]
      | { value: string | number; type: string; default?: string }[]
    type: string
  }[]
}

export const displayModel = {
  name: 'CS',
  taskInfoExpanded: [
    {
      key: '模式名称',
      value: 'mode',
      type: 'string',
    },
    {
      key: '任务分组',
      value: 'groupName',
      type: 'string',
    },
    {
      key: 'Agent',
      value: 'agentName',
      type: 'string',
    },
    {
      key: '容器主机名称',
      value: 'hostName',
      type: 'string',
    },
    {
      key: '安全域',
      value: 'areaName',
      type: 'string',
    },
    {
      key: '执行类型',
      value: [
        {
          value: 'scheduler_type',
          type: 'number',
          default: '立即',
        },
        {
          value: 'task_time_list',
          type: 'array',
          deepType: {
            item: 'string',
          },
        },
      ],
    },
    {
      key: '执行速率',
      value: 'sampleDeliveryRate',
      type: 'number',
    },
    {
      key: '任务优先级',
      value: 'priority',
      type: 'number|string',
    },
    {
      key: '创建时间',
      value: 'createTime',
      type: 'string',
    },
    {
      key: '任务模板',
      value: 'templates',
      type: 'array',
      deepType: {
        item: 'string',
      },
    },
    {
      key: '安全设备',
      value: 'devices',
      type: 'array',
      deepType: {
        device_brand: 'string',
        device_ip: 'string',
      },
    },
  ],
  taskInfo: [
    {
      key: '任务ID',
      value: 'taskId',
      type: 'string',
    },
    {
      key: '安全域',
      value: 'biz_area_name',
      type: 'string',
    },
    {
      key: '进度信息',
      value: [
        {
          value: 'isFinished',
          type: 'number',
        },
        {
          value: 'progressRate',
          type: 'number',
        },
        {
          value: 'successSum',
          type: 'number',
        },
        {
          value: 'failSum',
          type: 'number',
        },
      ],
    },
  ],
} as ModelType

export interface PluginDetailProps {
  id: string
  plugin_name: string
  supported_architectures: string[]
  supported_platforms: string[]
  params: {
    key: string
    value: string
    type: string
    description: string
  }[]
  tactic_list: { name: string; url: string }[]
  intercept_status: number
  risk_level: number
  attack_type: number
  attack_name: string
  describe: string
  solution: string
  apt_list: string[]
  update_time: string
  device_security: any[]
  plugin_log: any
  samples_list: { id: string; samples_name: string; samples_path: string; samples_sha256: string }[]
  principle: string
  start_time: string
  end_time: string
  resource_tag_list: V1TagCategory[]
  intercept_from: string
}

export interface V1TagCategory {
  tagCategoryName?: string
  tagName?: string[]
  [property: string]: any
}
